import dayjs from 'dayjs';
import AxiosAPI from '../../../utils/AxiosAPI';

// Get pending services
export const ApiGetPendingServices = () => {
    return new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/services/pending`)
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
};

// Initiate pending service
export const ApiMakeInitiateItem = (invoiceId, invoiceItemId) => {
    return new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/services-progress/initiate/${invoiceId}/${invoiceItemId}`)
            .post({
                invoiceId,
                invoiceItemId,
                ServiceStartDate: dayjs().format('YYYY-MM-DD')
            })
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export default null;
